<script setup lang="ts">
import { computed, ref } from "vue";

const props = withDefaults(
  defineProps<{
    id: string;
    label: string;
    type?: string;
    autocomplete?: string;
    required?: boolean;
    error?: string;
  }>(),
  { type: "text", required: false },
);

const model = defineModel<string>({ required: true });

const revealed = ref(false);
const isPassword = computed(() => props.type === "password");
const inputType = computed(() =>
  isPassword.value ? (revealed.value ? "text" : "password") : props.type,
);
</script>

<template>
  <div class="flex w-full flex-col gap-2">
    <label
      :for="id"
      class="text-left text-[13px] font-bold leading-none text-bnavy"
    >
      {{ label }}
    </label>

    <div
      class="flex h-8 w-full items-center gap-2 rounded-2xl bg-bnavy-10 px-3 py-1.5"
    >
      <input
        :id="id"
        v-model="model"
        :type="inputType"
        :required="required"
        :autocomplete="autocomplete"
        class="min-w-0 flex-1 border-none bg-transparent p-0 text-left text-sm font-medium text-bnavy placeholder:text-mystic focus:outline-none focus:ring-0"
      />
      <button
        v-if="isPassword"
        type="button"
        class="shrink-0"
        :aria-label="revealed ? 'Ocultar contraseña' : 'Mostrar contraseña'"
        @click="revealed = !revealed"
      >
        <img
          src="/img/auth/eye-slash.svg"
          alt=""
          class="h-4 w-4"
          :class="{ 'opacity-50': revealed }"
        />
      </button>
    </div>

    <p v-if="error" class="text-left text-xs text-red-500">{{ error }}</p>
  </div>
</template>
